import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "advanced-overriding-server-properties"
    }}>{`Advanced: Overriding server properties`}</h3>
    <p>{`Sometimes, you may want to evaluate feature flags using `}<a parentName="p" {...{
        "href": "/docs/product-analytics/person-properties"
      }}>{`person properties`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/product-analytics/group-analytics"
      }}>{`groups`}</a>{`, or group properties that haven't been ingested yet, or were set incorrectly earlier. `}</p>
    <p>{`You can provide properties to evaluate the flag with by using the `}<inlineCode parentName="p">{`person properties`}</inlineCode>{`, `}<inlineCode parentName="p">{`groups`}</inlineCode>{`, and `}<inlineCode parentName="p">{`group properties`}</inlineCode>{` arguments. PostHog will then use these values to evaluate the flag, instead of any properties currently stored on your PostHog server.`}</p>
    <p>{`For example: `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      